"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("components/base/Button"));
const Card_1 = require("components/base/Card");
const Layout_1 = require("components/base/Layout");
const Text_1 = __importDefault(require("components/base/Text"));
const CubePreview_1 = __importDefault(require("components/cube/CubePreview"));
const DynamicFlash_1 = __importDefault(require("components/DynamicFlash"));
const Markdown_1 = __importDefault(require("components/Markdown"));
const MtgImage_1 = __importDefault(require("components/MtgImage"));
const RenderToRoot_1 = __importDefault(require("components/RenderToRoot"));
const UserContext_1 = __importDefault(require("contexts/UserContext"));
const MainLayout_1 = __importDefault(require("layouts/MainLayout"));
const UserLayout_1 = __importDefault(require("layouts/UserLayout"));
const UserCubePage = ({ owner, followersCount, following, cubes, loginCallback = '/', }) => {
    const user = (0, react_1.useContext)(UserContext_1.default);
    return (react_1.default.createElement(MainLayout_1.default, { loginCallback: loginCallback },
        react_1.default.createElement(UserLayout_1.default, { user: owner, followersCount: followersCount, following: following, activeLink: "view" },
            react_1.default.createElement(DynamicFlash_1.default, null),
            react_1.default.createElement(Layout_1.Flexbox, { direction: "col", className: "my-3", gap: "2" },
                react_1.default.createElement(Card_1.Card, null,
                    react_1.default.createElement(Card_1.CardHeader, null,
                        react_1.default.createElement(Text_1.default, { semibold: true, lg: true }, "About")),
                    react_1.default.createElement(Card_1.CardBody, null,
                        react_1.default.createElement(Layout_1.Row, { className: "mb-3" },
                            owner.image && (react_1.default.createElement(Layout_1.Col, { xs: 4, lg: 3 },
                                react_1.default.createElement(MtgImage_1.default, { image: owner.image, showArtist: true }))),
                            react_1.default.createElement(Layout_1.Col, { xs: owner.image ? 8 : 12, lg: owner.image ? 9 : 12 },
                                react_1.default.createElement(Markdown_1.default, { markdown: owner.about || '_This user has not yet filled out their about section._' }))),
                        user && user.id === owner.id && (react_1.default.createElement(Button_1.default, { type: "link", color: "accent", block: true, href: "/user/account" }, "Update")))),
                react_1.default.createElement(Layout_1.Row, null, cubes.map((cube) => (react_1.default.createElement(Layout_1.Col, { key: cube.id, className: "mt-3", xs: 6, sm: 4, md: 3, xl: 2 },
                    react_1.default.createElement(CubePreview_1.default, { cube: cube })))))))));
};
exports.default = (0, RenderToRoot_1.default)(UserCubePage);
